var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMarketplace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.16667C0 3.72464 0.175595 3.30072 0.488155 2.98816C0.800716 2.67559 1.22464 2.5 1.66667 2.5H10.8333C11.2754 2.5 11.6993 2.67559 12.0118 2.98816C12.3244 3.30072 12.5 3.72464 12.5 4.16667V5.83333H10.8333V4.16667H1.66667V10H6.66667V11.6667H1.66667V15H6.66667V16.6667H4.51167L2.91667 18.2617L1.73833 17.0833L2.155 16.6667H1.66667C1.22464 16.6667 0.800716 16.4911 0.488155 16.1785C0.175595 15.8659 0 15.442 0 15V4.16667ZM9.43583 6.66667H18.0642L20 11.5058V17.9167H18.3333V16.6667H9.16667V17.9167H7.5V11.5058L9.43583 6.66667ZM9.16667 15H18.3333V11.8275L18.2692 11.6667H9.23083L9.16667 11.8275V15ZM9.8975 10H17.6025L16.9358 8.33333H10.5642L9.8975 10ZM2.5 12.5H4.17V14.17H2.5V12.5ZM10 12.5H11.67V14.17H10V12.5ZM15.8333 12.5H17.5033V14.17H15.8333V12.5Z",
    fill: "#9C4900",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarketplace);
export default __webpack_public_path__ + "static/media/ic_marketplace.b72bafec2eb8c801ca7251f54c72a0a5.svg";
export { ForwardRef as ReactComponent };